<template>
  <v-container fluid>
    <div v-if="sleuthConfig">
      <div class="text-h5 text-left">Post Checking</div>
      <v-divider></v-divider>
      <div class="text-subtitle-2 mt-2 mb-2 text-left grey--text text--darken-1">
        Enable / Disable the type of post checking you wish to perform
      </div>

      <v-row class="mb-4">
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.check_image_posts" label="Images" hint="Check Images" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.check_link_posts" label="Links" hint="Check Links" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch label="Videos" hint="Coming Soon" persistent-hint disabled></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch label="Text" hint="Coming Soon" persistent-hint disabled></v-switch>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "PostCheckingSettings",
  props: {
    sleuthConfig: Object
  }
}
</script>

<style scoped>

</style>
